const invitation = {
    find_your_tenants: 'یافتن مستاجران شما',
    find_tenants_description: 'آدرس ایمیل شما ممکن است قبلاً با چندین مستاجر ثبت شده باشد. می‌توانید به موارد موجود بپیوندید یا یک مستاجر جدید ایجاد کنید.',
    create_new_tenant: 'ایجاد مستاجر جدید',
    email_not_match_title: 'در حال حاضر با\n{{email}} وارد شده‌اید',
    email_not_match_description: 'لطفاً با حساب کاربری صحیح وارد شوید تا دعوت‌نامه را بپذیرید و عضو سازمان شوید.',
    switch_account: 'ورود به حساب دیگر',
    invalid_invitation_status: 'دعوت‌نامه نامعتبر است. لطفاً با مدیر تماس بگیرید و دوباره تلاش کنید.',
    invitation_not_found: 'دعوت‌نامه یافت نشد. لطفاً با مدیر تماس بگیرید.',
};
export default Object.freeze(invitation);
